import PropTypes from 'prop-types';
import React, { Component } from 'react';
const crazyListerLogo = require('./images/footer.png');

const styles = {
  container: {
    textAlign: 'center',
    fontSize: '15px',
    backgroundColor: '#fff',
    paddingTop: '10px',
    fontFamily: 'Open Sans'
  },
  link: {
    color: '#000',
    textDecoration: 'none',
    display: 'block',
    width: 215,
    margin: '0 auto',
    position: 'relative'
  },
  textWrapper: {
    position: 'relative',
    top: '-14px',
    left: '7px'
  },
  text: {
    marginLeft: '5px'
  }
};

export default class MobileCopyrightAd extends Component {

  render() {
    const {style} = this.props;
    return (
      <div style={{...styles.container, ...style}} className="cl-copyright-mobile" id="cl-copyright-footer-mobile">
        <a href="https://crazylister.com/?utm_source=CrazyLister&utm_medium=Listings&utm_campaign=Footer" style={styles.link}>
          <img src={crazyListerLogo} alt="Crazylister" title="Crazylister"/>
        </a>
      </div>
    );
  }
}

MobileCopyrightAd.propTypes = {
  style: PropTypes.object,
};

MobileCopyrightAd.defaultProps = {
  style: {},
};